import axios from "axios";
import { URL } from "./url"

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    get: (url) => {
        return axios.get(URL + url);
    },
}